import { UseMutationResult } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { useDispatch } from 'react-redux';

export const useSetTransactionPasswordQuery = () => {
	const dispatch = useDispatch();

	return useMutationHook(
		[endPointUrls.PROFILE_CHANGE_TRANSACTION_PASSWORD],
		(data) => api.post(endPointUrls.PROFILE_CHANGE_TRANSACTION_PASSWORD, data),
		{
			onSuccess: (res: any) => {
				if (res?.status === 200) {
					toastHandler('success', res?.data.message);
					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult;
};
